<template>
  <div class="container flex-wrap" style="flex-wrap:wrap;gap:10px;align-content:flex-start;padding:10px;overflow-y:auto;">


    <template v-for="item in items">
        <div :key="item.key" class="hover-lighter" style="width:260px;height:60px;background:var(--border);border-radius:5px;padding:10px" @click="getInfo(item)">
            <div>{{item.name}}</div>
            <div style="color:var(--subtext2);font-size:12px;">{{item.tableName}}</div>
        </div>
    </template>

    <Drawer v-model="showModalInfo" title="详情" :transfer="false" :width="800">
        <h2 style="margin-bottom:10px;">{{selected.name || '测试标题'}}</h2>

        <!-- 暂时注释掉 BaseSegment 组件 -->

        <BaseSegment title="FIELDS" v-if="selected.fields && selected.fields.length > 0">
            <template v-for="f in selected.fields">
                <div :key="f.key" class="flex-wrap">
                    <div :style="`font-weight:bold;color:var(${f.composed?'--warning':'--error'})`">{{f.key}}</div>
                    <div style="margin-left:10px;color:var(--primary)">{{f.type}}</div>
                </div>
            </template>
        </BaseSegment>
        <BaseSegment title="COMPOSED" v-if="selected.composed && selected.composed.length > 0">
            <template v-for="f in selected.composed">
                <div :key="f.key" class="flex-wrap">
                    <div style="font-weight:bold;color:var(--warning)">{{f.key}}</div>
                    <div style="margin-left:10px;color:var(--subtext2);font-size:12px;">{{ f.composed_type }}</div>
                    <div style="margin-left:10px;color:var(--primary);cursor:pointer;" @click="getInfo({key:f.type})">{{f.type}}</div>
                </div>
            </template>
        </BaseSegment>
        <BaseSegment title="COMPUTED" v-if="selected.computed && selected.computed.length > 0">
            <template v-for="f in selected.computed">
                <div :key="f.key" class="flex-wrap">
                    <div style="font-weight:bold;color:var(--success)">{{f.key}}</div>
                    <div style="margin-left:10px;color:var(--primary)" >{{f.type}}</div>
                </div>
            </template>
        </BaseSegment>

    </Drawer>

  </div>
</template>

<script>
export default {
  data() {
    return {
      showModalInfo: false,
      items: [],
      selected: {
        name: '',
        fields: [],
        computed: [],
        composed: [],
      },
    };
  },
  mounted() {
    console.log('Component mounted, starting data fetch...');
    this.$api.afterLogin(()=>{
      console.log('After login callback triggered');
      this.getData();
    });
  },
  methods: {
    getInfo(item) {
      console.log('getInfo called with:', item);
      this.$api.get(`admin/models/${item.key}`).then((res)=>{
        console.log('Model info response:', res.data);
        this.selected = res.data.data;
        this.showModalInfo = true;
      }).catch((err) => {
        console.error('Error fetching model info:', err);
      });
    },
    getData() {
      console.log('getData called');
      this.$api.get('admin/models').then((res)=>{
        console.log('Models data response:', res.data);
        this.items = res.data.data;
      }).catch((err) => {
        console.error('Error fetching models:', err);
      });
    },
  },
};
</script>

<style>

</style>
